import { FC } from 'react';
import { Icon } from 'src/components';
import { UserPathBlob } from 'src/api/userPath/types';
import { BlobImage } from '../BlobPathComponent/BlobImage';
import * as S from './styles';

export const CompletedWordlistImage: FC<{
  blob: Pick<UserPathBlob, 'type' | 'iconUrl' | 'photoUrl'>;
  compact?: boolean;
}> = ({ blob, compact = false }) => (
  <S.Image aria-hidden>
    <BlobImage blob={blob} iconOnly={blob.type === 'scenario'} />
    <S.Check $compact={compact}>
      <Icon name="check" />
    </S.Check>
  </S.Image>
);
